/*
 * Public API Surface of Filtered Table Component
 */

export * from './filtered-table.module';
export * from './components/filtered-table/filtered-table.component';
